export const TEXT_BANNER = "Please select dates to see availability and select your room.";
export const ERROR_BANNER = "Your current date selection is unavailable. " + TEXT_BANNER;
